import { ReactNode } from 'react';

export interface MetricCellData {
	label: string;
	value: ReactNode;
	hint?: ReactNode;
	tone?: 'default' | 'success' | 'warning' | 'muted';
}

const TONE_CLASS: Record<NonNullable<MetricCellData['tone']>, string> = {
	default: 'text-foreground',
	success: 'text-emerald-600',
	warning: 'text-amber-600',
	muted: 'text-muted-foreground'
};

/**
 * Top-of-page dashboard strip on the Deals list (Total / Weighted / Open /
 * Closed / New deal amount + Avg deal age). Reusable for other list pages
 * that want headline metrics.
 */
export function MetricsRow({ metrics }: { metrics: MetricCellData[] }) {
	return (
		<div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border bg-border md:grid-cols-3 lg:grid-cols-6">
			{metrics.map((m, i) => (
				<div key={i} className="flex flex-col gap-1 bg-card px-4 py-3">
					<div className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">{m.label}</div>
					<div className={`text-xl font-semibold tabular-nums ${TONE_CLASS[m.tone || 'default']}`}>{m.value}</div>
					{m.hint && <div className="text-xs text-muted-foreground">{m.hint}</div>}
				</div>
			))}
		</div>
	);
}
